var React = require('react');

function LyraPage (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","fillRule":"evenodd","strokeWidth":"1"},React.createElement("g",{"id":"Atom/Icon/Document/BlueNew"},React.createElement("g",{"id":"Atom/Icon/Document/Blue"},[React.createElement("rect",{"id":"Rectangle","width":"5.75","height":"23","x":"20.125","y":"2.875","key":0}),React.createElement("rect",{"id":"Rectangle-Copy","width":"5.75","height":"23","x":"29.1455231","y":"11.6975861","transform":"translate(32.020523, 23.197586) rotate(-270.000000) translate(-32.020523, -23.197586) ","key":1}),React.createElement("path",{"id":"Rectangle","fill":"none","strokeWidth":"6","d":"M3,3 L3,43 L43,43 L43,19 C43,10.163444 35.836556,3 27,3 L6,3 Z","key":2})]))));
}

LyraPage.defaultProps = {"className":"fill-current stroke-current","version":"1.1","viewBox":"0 0 46 46"};

module.exports = LyraPage;

LyraPage.default = LyraPage;
